// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"b22b6dda","185":"5cad8e53","220":"9a748664","375":"d65e018e","453":"ee9dd304","577":"a23e574c","693":"d099250d","739":"68e25c86","952":"8f41fc39"}[chunkId] + ".chunk.js";
};